(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-abar]');

    bars.forEach(function (abar) {
      var list = abar.querySelector('[data-abar-list]');
      var items = abar.querySelectorAll('.abar__item');
      if (!list || items.length < 2) return;

      // The one lever left once the manual pause control was explicitly declined. This is
      // the platform's own advance instruction not to run motion like this, set once for
      // every site rather than per component, and it was never in question — only the
      // per-component control was. Checked once, before the interval ever starts, rather
      // than started and immediately stopped: starting anything, even briefly, is motion the
      // preference asks not to happen.
      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      // Only below 64rem. Above it every statement already shows at once in the static
      // layout, so there is nothing to advance.
      var mobile = window.matchMedia && window.matchMedia('(max-width: 63.99rem)');
      if (!mobile || !mobile.matches) return;

      var INTERVAL_MS = 5000;
      var index = 0;
      var timer = null;

      function show(i) {
        items.forEach(function (item, itemIndex) {
          item.classList.toggle('abar__item--current', itemIndex === i);
        });
      }

      function advance() {
        index = (index + 1) % items.length;
        show(index);
      }

      function start() {
        if (timer) return;
        list.setAttribute('aria-live', 'polite');
        timer = window.setInterval(advance, INTERVAL_MS);
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
        list.setAttribute('aria-live', 'off');
      }

      abar.classList.add('abar--auto');
      show(index);
      start();

      // Not a customer-facing pause: a hidden tab is not "on screen" for anyone, so nothing
      // is skipped by stopping here, and resuming costs nothing extra since the interval
      // simply restarts fresh rather than trying to account for time missed.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands"]) return;
  try {
    
  (function () {
    var searchInput = document.getElementById('brands-search-input');
    var alphaButtons = document.querySelectorAll('.brands__alpha-btn');
    var cards = document.querySelectorAll('#brands-grid .bcard');
    var emptyEl = document.getElementById('brands-empty');
    var countEl = document.getElementById('brands-count');

    var currentLetter = 'ALL';
    var currentQuery = '';

    function filterBrands() {
      var visibleCount = 0;

      cards.forEach(function (card) {
        var name = (card.getAttribute('data-brand-name') || '').toLowerCase();
        var letter = (card.getAttribute('data-brand-letter') || '').toUpperCase();

        var matchesLetter = (currentLetter === 'ALL' || letter === currentLetter);
        var matchesQuery = (!currentQuery || name.indexOf(currentQuery) !== -1);

        if (matchesLetter && matchesQuery) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      if (emptyEl) {
        emptyEl.style.display = visibleCount === 0 ? '' : 'none';
      }

      if (countEl) {
        countEl.textContent = visibleCount + ' Houses';
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        currentQuery = (e.target.value || '').trim().toLowerCase();
        filterBrands();
      });
    }

    alphaButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        alphaButtons.forEach(function (b) { b.classList.remove('brands__alpha-btn--active'); });
        btn.classList.add('brands__alpha-btn--active');
        currentLetter = btn.getAttribute('data-letter') || 'ALL';
        filterBrands();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Upgrades the search link into an expanding field. Everything here is additive: with this
  // script absent the trigger stays a working link to the search page, which is why it is
  // marked up as an anchor rather than a button.
  (function () {
    var host = document.querySelector('[data-search-host]');
    if (!host) return;

    var toggle = host.querySelector('[data-search-toggle]');
    var panel = host.querySelector('[data-search-panel]');
    var input = host.querySelector('[data-search-input]');
    if (!toggle || !panel || !input) return;

    var OPEN_CLASS = 'site-head--searching';

    // Only announce a collapsed/expanded state once we can actually deliver one. Declaring
    // aria-expanded in the markup would describe behaviour that does not exist without JS.
    toggle.setAttribute('aria-expanded', 'false');

    function isOpen() {
      return host.classList.contains(OPEN_CLASS);
    }

    // Below 64rem both the search field and the menu occupy the band directly beneath the
    // header, so opening one has to dismiss the other or they stack on top of each other.
    var navmenu = document.querySelector('[data-navmenu]');

    function open() {
      if (navmenu) navmenu.open = false;
      host.classList.add(OPEN_CLASS);
      toggle.setAttribute('aria-expanded', 'true');
      input.focus();
    }

    function close(returnFocus) {
      host.classList.remove(OPEN_CLASS);
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      if (isOpen()) {
        close(true);
      } else {
        open();
      }
    });

    // Outside click. The guard keeps a press on the toggle itself from being handled twice,
    // which would open and immediately close again.
    document.addEventListener('click', function (event) {
      if (!isOpen()) return;
      if (host.contains(event.target)) return;
      close(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !isOpen()) return;
      close(true);
    });

    // An empty submission would navigate to a results page for nothing. Close instead, which
    // matches what a second press on the icon does.
    panel.addEventListener('submit', function (event) {
      if (input.value.trim() !== '') return;
      event.preventDefault();
      close(true);
    });

    if (navmenu) {
      // The other half of the same rule. A <details> has no close event, so its toggle is
      // watched instead.
      navmenu.addEventListener('toggle', function () {
        if (navmenu.open && isOpen()) close(false);
      });

      // Escape closes the menu too. Without this the field responds to Escape and the menu
      // does not, which reads as one of them being broken.
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !navmenu.open) return;
        navmenu.open = false;
        var summary = navmenu.querySelector('summary');
        if (summary) summary.focus();
      });

      // Outside click, matching the field's behaviour.
      document.addEventListener('click', function (event) {
        if (!navmenu.open) return;
        if (navmenu.contains(event.target)) return;
        navmenu.open = false;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-hero-rotate]');

    roots.forEach(function (root) {
      var radios = root.querySelectorAll('.hero__radio');
      var interval = parseInt(root.getAttribute('data-hero-interval'), 10);
      var deck = root.querySelector('.hero__deck');

      if (radios.length < 2 || !deck || !interval || interval < 2000) return;

      var reduce = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;

      var hovering = false;
      var focused = false;
      var offscreen = false;
      var pausedUntil = 0;
      var timer = null;

      function currentIndex() {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) return i;
        }
        return 0;
      }

      function goTo(index) {
        var target = (index + radios.length) % radios.length;
        radios[target].checked = true;
      }

      function advance() {
        if (Date.now() < pausedUntil) return;
        goTo(currentIndex() + 1);
      }

      function shouldRun() {
        if (hovering || focused || offscreen) return false;
        if (document.hidden) return false;
        if (reduce && reduce.matches) return false;
        return true;
      }

      function sync() {
        if (shouldRun()) {
          if (!timer) timer = window.setInterval(advance, interval);
          return;
        }
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      // When manually changed (via radio, indicator label, or swipe), pause auto-advance for 8 seconds, then resume smoothly
      root.addEventListener('change', function () {
        pausedUntil = Date.now() + 8000;
        sync();
      });

      // Only track hover on mouse-capable devices so touch events on mobile do not permanently freeze hover state
      var hasHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      if (hasHover) {
        deck.addEventListener('mouseenter', function () {
          hovering = true;
          sync();
        });

        deck.addEventListener('mouseleave', function () {
          hovering = false;
          sync();
        });
      }

      deck.addEventListener('focusin', function () {
        focused = true;
        sync();
      });

      deck.addEventListener('focusout', function (event) {
        if (deck.contains(event.relatedTarget)) return;
        focused = false;
        sync();
      });

      document.addEventListener('visibilitychange', sync);

      if (window.IntersectionObserver) {
        new window.IntersectionObserver(function (records) {
          records.forEach(function (record) {
            offscreen = !record.isIntersecting;
          });
          sync();
        }).observe(deck);
      }

      if (reduce && reduce.addEventListener) {
        reduce.addEventListener('change', sync);
      }

      // --- Touch Swipe Support for Mobile ---
      var touchStartX = 0;
      var touchStartY = 0;
      var touchEndX = 0;
      var touchEndY = 0;

      deck.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches && e.touches[0]) {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
          }
        },
        { passive: true }
      );

      deck.addEventListener(
        'touchend',
        function (e) {
          if (e.changedTouches && e.changedTouches[0]) {
            touchEndX = e.changedTouches[0].clientX;
            touchEndY = e.changedTouches[0].clientY;
            handleSwipe();
          }
        },
        { passive: true }
      );

      function handleSwipe() {
        var dx = touchEndX - touchStartX;
        var dy = touchEndY - touchStartY;
        // Minimum horizontal threshold (36px) and ensure horizontal intent
        if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.1) {
          if (dx < 0) {
            // Swiped left -> Next card
            goTo(currentIndex() + 1);
          } else {
            // Swiped right -> Previous card
            goTo(currentIndex() - 1);
          }
          pausedUntil = Date.now() + 8000;
          sync();
        }
      }

      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // ──── Gallery Controller ────
    var galleries = document.querySelectorAll('[data-gallery]');
    var reduceMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;
    var scrollBehavior = reduceMotion ? 'auto' : 'smooth';

    galleries.forEach(function (gallery) {
      var viewer = gallery.querySelector('[data-gallery-viewer]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var counter = gallery.querySelector('[data-gallery-counter]');
      if (!viewer || thumbs.length === 0) return;

      var frames = gallery.querySelectorAll('[data-gallery-frame]');
      var total = frames.length;

      function setActive(index) {
        var idxNum = parseInt(index, 10);
        thumbs.forEach(function (thumb) {
          var isActive = thumb.getAttribute('data-gallery-thumb') === String(index);
          thumb.classList.toggle('pdp__thumb--active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });

        if (counter) {
          var curStr = idxNum < 10 ? '0' + idxNum : '' + idxNum;
          var totStr = total < 10 ? '0' + total : '' + total;
          counter.textContent = curStr + ' / ' + totStr;
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          var index = thumb.getAttribute('data-gallery-thumb');
          var frame = gallery.querySelector('#pdp-image-' + index);
          if (!frame) return;
          event.preventDefault();
          frame.scrollIntoView({ behavior: scrollBehavior, inline: 'start', block: 'nearest' });
          setActive(index);
        });
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var index = Array.prototype.indexOf.call(frames, entry.target) + 1;
              setActive(index);
            });
          },
          { root: viewer, threshold: 0.6 }
        );
        frames.forEach(function (frame) { observer.observe(frame); });
      }
    });

    // ──── Quantity Stepper ────
    var STEP = '[data-qty-step]';
    var FORM = '[data-pdp-form]';

    var btns = document.querySelectorAll(STEP + '[hidden]');
    for (var i = 0; i < btns.length; i++) btns[i].hidden = false;

    document.addEventListener('click', function (event) {
      var step = event.target.closest ? event.target.closest(STEP) : null;
      if (!step) return;

      var form = step.closest(FORM);
      var input = form && form.querySelector('[data-qty-input]');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = next < min ? min : next;
    });

    // ──── AJAX Add to Cart ────
    document.addEventListener('submit', function (event) {
      var form = event.target.closest ? event.target.closest(FORM) : null;
      if (!form) return;
      if (!window.fetch) return;

      event.preventDefault();

      var submit = form.querySelector('[data-pdp-submit]');
      if (submit && submit.getAttribute('aria-busy') === 'true') return;
      if (submit) submit.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          var originalHTML = submit ? submit.innerHTML : '';
          if (submit) {
            submit.innerHTML = '<span>[ ADDED &#10003; ]</span>';
            setTimeout(function () {
              if (submit) submit.innerHTML = originalHTML;
            }, 1200);
          }

          document.dispatchEvent(new CustomEvent('dunemark:cart-updated', {
            detail: { open: false, sourceEl: form }
          }));
        })
        .catch(function () {
          form.submit();
        })
        .then(function () {
          if (submit) submit.removeAttribute('aria-busy');
        });
    });

    // ──── Olfactory Pyramid Manifest Parser ────
    var olfContainers = document.querySelectorAll('[data-olfactory-container]');
    olfContainers.forEach(function (container) {
      var rawEl = container.querySelector('[data-olfactory-raw]');
      if (!rawEl) return;

      var text = rawEl.innerHTML
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n\n')
        .replace(/<p[^>]*>/gi, '')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim();

      var secPatterns = [
        { regex: /^(?:top\s+notes?|head\s+notes?)(?:\s*[:-]+|\s*$)/i, title: 'TOP NOTES', tag: 'HEAD' },
        { regex: /^(?:heart\s+notes?|middle\s+notes?)(?:\s*[:-]+|\s*$)/i, title: 'HEART NOTES', tag: 'HEART' },
        { regex: /^(?:base\s+notes?|dry\s*down\s+notes?)(?:\s*[:-]+|\s*$)/i, title: 'BASE NOTES', tag: 'BASE' },
        { regex: /^(?:fragrance\s+profile(?:\s+summary)?|olfactory\s+pyramid|scent\s+profile)(?:\s*[:-]+|\s*$)/i, title: 'FRAGRANCE PROFILE', tag: 'PROFILE' }
      ];

      var lines = text.split('\n');
      var sections = [];
      var curSec = null;

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (!line) continue;

        var matched = null;
        for (var j = 0; j < secPatterns.length; j++) {
          if (secPatterns[j].regex.test(line)) {
            matched = secPatterns[j];
            break;
          }
        }

        if (matched) {
          curSec = { title: matched.title, tag: matched.tag, items: [] };
          sections.push(curSec);
        } else {
          var cleanItem = line.replace(/^[\*\-\•]\s*/, '').trim();
          if (cleanItem) {
            if (!curSec) {
              curSec = { title: 'FRAGRANCE PROFILE', tag: 'PROFILE', items: [] };
              sections.push(curSec);
            }
            curSec.items.push(cleanItem);
          }
        }
      }

      if (sections.length >= 2) {
        var grid = document.createElement('div');
        grid.className = 'pdp__olfactory-grid';

        for (var k = 0; k < sections.length; k++) {
          var s = sections[k];
          if (s.items.length === 0) continue;

          var card = document.createElement('div');
          card.className = 'pdp__olfactory-card';

          var cardHead = document.createElement('div');
          cardHead.className = 'pdp__olfactory-card-head';

          var h3 = document.createElement('h3');
          h3.className = 'pdp__olfactory-card-title dm-label';
          h3.textContent = s.title;

          var tag = document.createElement('span');
          tag.className = 'pdp__olfactory-card-tag dm-micro';
          tag.textContent = '[' + s.tag + ']';

          cardHead.appendChild(h3);
          cardHead.appendChild(tag);
          card.appendChild(cardHead);

          var ul = document.createElement('ul');
          ul.className = 'pdp__olfactory-list';

          for (var m = 0; m < s.items.length; m++) {
            var li = document.createElement('li');
            li.className = 'pdp__olfactory-item';

            var bullet = document.createElement('span');
            bullet.className = 'pdp__bullet';
            bullet.setAttribute('aria-hidden', 'true');

            var textSpan = document.createElement('span');
            textSpan.className = 'pdp__olfactory-text';
            textSpan.textContent = s.items[m];

            li.appendChild(bullet);
            li.appendChild(textSpan);
            ul.appendChild(li);
          }

          card.appendChild(ul);
          grid.appendChild(card);
        }

        rawEl.style.display = 'none';
        var bodyEl = container.querySelector('.pdp__detail-body');
        var sourceEl = container.querySelector('.pdp__detail-source');
        if (bodyEl && sourceEl) {
          bodyEl.insertBefore(grid, sourceEl);
        } else if (bodyEl) {
          bodyEl.appendChild(grid);
        }
      }
    });

    // ──── Mobile Sticky Purchase Bar Controller ────
    var mobileBar = document.querySelector('[data-mobile-bar]');
    if (mobileBar) {
      var mobileInput = mobileBar.querySelector('[data-mobile-qty-input]');
      var mobileSelect = mobileBar.querySelector('[data-mobile-variant-select]');
      var mobilePrice = mobileBar.querySelector('[data-mobile-price]');
      var mobileSubmit = mobileBar.querySelector('[data-mobile-submit]');
      var mainForm = document.querySelector('[data-pdp-form]');
      var mainInput = mainForm ? mainForm.querySelector('[data-qty-input]') : null;

      mobileBar.addEventListener('click', function (event) {
        var stepBtn = event.target.closest ? event.target.closest('[data-mobile-qty-step]') : null;
        if (!stepBtn || !mobileInput) return;
        var min = parseInt(mobileInput.getAttribute('min') || '1', 10);
        var cur = parseInt(mobileInput.value, 10) || min;
        var diff = parseInt(stepBtn.getAttribute('data-mobile-qty-step'), 10);
        var next = cur + diff;
        mobileInput.value = next < min ? min : next;
        if (mainInput) mainInput.value = mobileInput.value;
      });

      if (mainInput && mobileInput) {
        mainInput.addEventListener('input', function () {
          mobileInput.value = mainInput.value;
        });
      }

      if (mobileSelect) {
        mobileSelect.addEventListener('change', function () {
          var opt = mobileSelect.options[mobileSelect.selectedIndex];
          if (opt && mobilePrice) {
            var price = opt.getAttribute('data-price');
            if (price) mobilePrice.textContent = price;
          }
          if (opt && opt.disabled) {
            mobileSubmit.disabled = true;
          } else {
            mobileSubmit.disabled = false;
          }
          if (mainForm) {
            var hiddenId = mainForm.querySelector('input[name="id"]');
            if (hiddenId) hiddenId.value = mobileSelect.value;
          }
        });
      }

      if (mobileSubmit) {
        mobileSubmit.addEventListener('click', function (event) {
          event.preventDefault();
          if (mobileSubmit.getAttribute('aria-busy') === 'true') return;
          mobileSubmit.setAttribute('aria-busy', 'true');

          var variantId = mobileSelect ? mobileSelect.value : (mainForm ? mainForm.querySelector('input[name="id"]').value : null);
          var qty = mobileInput ? mobileInput.value : '1';

          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', qty);

          fetch('/cart/add.js', { method: 'POST', body: formData })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              return res.json();
            })
            .then(function () {
              var originalHTML = mobileSubmit ? mobileSubmit.innerHTML : '';
              if (mobileSubmit) {
                mobileSubmit.innerHTML = '<span>[ ADDED &#10003; ]</span>';
                setTimeout(function () {
                  if (mobileSubmit) mobileSubmit.innerHTML = originalHTML;
                }, 1200);
              }

              document.dispatchEvent(new CustomEvent('dunemark:cart-updated', {
                detail: { open: false, sourceEl: mobileBar }
              }));
            })
            .catch(function () {
              if (mainForm) mainForm.submit();
            })
            .then(function () {
              mobileSubmit.removeAttribute('aria-busy');
            });
        });
      }

      // ──── Sticky Mobile Bar Smart Visibility ────
      var purchaseBlock = document.querySelector('.pdp__purchase');
      if (purchaseBlock && 'IntersectionObserver' in window) {
        var buyObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                mobileBar.classList.remove('pdp__mobile-bar--visible');
                document.body.classList.remove('pdp-bar-active');
              } else {
                if (entry.boundingClientRect.top < 0) {
                  mobileBar.classList.add('pdp__mobile-bar--visible');
                  document.body.classList.add('pdp-bar-active');
                } else {
                  mobileBar.classList.remove('pdp__mobile-bar--visible');
                  document.body.classList.remove('pdp-bar-active');
                }
              }
            });
          },
          { threshold: 0.1 }
        );
        buyObserver.observe(purchaseBlock);
      }
    }

    // ──── Shopify Inbox Review Trigger ────
    document.addEventListener('click', function (e) {
      var inboxBtn = e.target.closest ? e.target.closest('[data-open-inbox]') : null;
      if (!inboxBtn) return;
      e.preventDefault();

      // 1. Direct ShopifyChat global API
      if (window.ShopifyChat) {
        if (typeof window.ShopifyChat.open === 'function') {
          window.ShopifyChat.open();
          return;
        }
        if (typeof window.ShopifyChat.show === 'function') {
          window.ShopifyChat.show();
          return;
        }
      }

      // 2. Dispatch custom Shopify chat events
      window.dispatchEvent(new CustomEvent('shopify:chat:open'));
      window.dispatchEvent(new CustomEvent('ShopifyChat:open'));

      // 3. Click Shopify Inbox iframe / launcher element
      var chatIframe = document.querySelector(
        '#dummy-chat-button-iframe, iframe[title="Shopify Inbox"], iframe#chat-button-iframe, iframe[id*="chat-button"]'
      );
      if (chatIframe) {
        try {
          if (chatIframe.contentDocument) {
            var innerBtn = chatIframe.contentDocument.querySelector('button, [role="button"]');
            if (innerBtn) {
              innerBtn.click();
              return;
            }
          }
        } catch (err) {
          // Cross-origin iframe fallback
        }
        chatIframe.click();
        return;
      }

      // 4. Standalone chat button or widget in DOM
      var domChatBtn = document.querySelector('#shopify-chat-button, [data-shopify-chat], .shopify-chat-button');
      if (domChatBtn) {
        domChatBtn.click();
        return;
      }

      // 5. Fallback if Shopify Inbox app is not installed/loading
      var productTitle = document.querySelector('.pdp__title') ? document.querySelector('.pdp__title').textContent.trim() : '';
      window.location.href = 'mailto:info@dunemark.com?subject=' + encodeURIComponent('Product Review: ' + productTitle);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-testimonials]');
    if (!section) return;
    var items = section.querySelectorAll('[data-testimonial]');
    var dots = section.querySelectorAll('[data-dot]');
    var stage = section.querySelector('[data-test-stage]');
    if (items.length < 2) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var INTERVAL_MS = 5000;
    var RESUME_DELAY_MS = 8000;
    var index = 0;
    var timer = null;
    var resumeTimer = null;

    function show(i) {
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      index = i;

      items.forEach(function (item, itemIndex) {
        item.classList.toggle('testimonial--current', itemIndex === index);
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('testimonials__dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function advance() {
      show(index + 1);
    }

    function start() {
      if (reduceMotion) return;
      if (timer) return;
      timer = window.setInterval(advance, INTERVAL_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function deferResume() {
      stop();
      resumeTimer = window.setTimeout(start, RESUME_DELAY_MS);
    }

    show(index);
    if (!reduceMotion) start();

    // Dot clicking
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetIndex = parseInt(dot.getAttribute('data-dot'), 10);
        show(targetIndex);
        deferResume();
      });
    });

    // Touch Swipe Gesture
    var startX = 0;
    var startY = 0;
    var isSwiping = false;

    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isSwiping = true;
          stop();
        }
      }, { passive: true });

      stage.addEventListener('touchend', function (e) {
        if (!isSwiping) return;
        isSwiping = false;
        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var diffX = endX - startX;
        var diffY = endY - startY;

        // Horizontal swipe detected (threshold: 35px, horizontal > vertical)
        if (Math.abs(diffX) > 35 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX < 0) {
            show(index + 1);
          } else {
            show(index - 1);
          }
        }
        deferResume();
      }, { passive: true });
    }

    // Mouse pause on hover
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', function () {
      if (!reduceMotion) start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else if (!reduceMotion) {
        start();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
